import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    user_guid: null,
    first_name: '',
    last_name: '',
    email: null,
    enabled: 0,
    authority: [],
}

export const userSlice = createSlice({
    name: 'auth/user',
    initialState,
    reducers: {
        setUser: (_, action) => action.payload,
        userLoggedOut: () => initialState,
    },
})

export const { setUser } = userSlice.actions

export default userSlice.reducer
